// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  droidId: __t.u64().primaryKey().name("droid_id"),
  owner: __t.identity(),
  poolMilli: __t.i64().name("pool_milli"),
  bonusMilli: __t.i64().name("bonus_milli"),
  spentMilli: __t.i64().name("spent_milli"),
  fundedTotal: __t.i64().name("funded_total"),
  salesSov: __t.i64().name("sales_sov"),
  saleSeq: __t.u32().name("sale_seq"),
  saleSeen: __t.u32().name("sale_seen"),
  stepAt: __t.timestamp().name("step_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
